import Text from 'app/Components/twComponents/Text'
import React, {useState} from 'react'
import {_} from 'plugins/i18n'
import {Accordion} from '../Components'
import {
	AddressInputs,
	ConsentsInputs,
	ContactInputs,
	ExtrasInputs,
	GuestsAndTaxPanel,
	InsuranceCancellationPanel,
	NextStepButton,
	ReservationSubmitButton,
} from './Components'
import {useReservationFormState} from '../hooks'
import {normalizeExtras} from '../helpers'
import {COND_PAYINADVANCE, COND_PAYTHERE} from 'app/_server/database/constants'

const ReservationSteps = () => {
	const [step, setStep] = useState(1)
	const {formValue} = useReservationFormState()
	const {contract} = formValue || {}
	const {house} = contract || {}
	const {extras: houseExtras} = house || {}

	const extrasToDisplay = normalizeExtras(houseExtras).filter(
		e =>
			(e.condition === COND_PAYINADVANCE && (!!e.pet || !e.required)) ||
			(e.condition === COND_PAYTHERE && !e.required)
	)
	const showOptions = extrasToDisplay.length > 0 ? 1 : 0

	const handleNextStep = (nextStep: number) => {
		if (nextStep > 4) return
		setStep(nextStep)
	}

	return (
		<>
			<Accordion
				step={1}
				maxStep={3 + showOptions}
				title="GuestsLabel"
				disabled={!step}
				isOpenInit={step === 1}
				classNameInner="flex w-full flex-col items-start gap-6"
			>
				<>
					<GuestsAndTaxPanel />
					<NextStepButton onClick={() => handleNextStep(2)} />
				</>
			</Accordion>
			{showOptions === 1 && (
				<Accordion
					step={2}
					maxStep={3 + showOptions}
					title="AdditionalOptionsLabel"
					disabled={step < 2}
					isOpenInit={step === 2}
					classNameInner="flex w-full flex-col items-start gap-6"
				>
					<>
						<ExtrasInputs />
						<NextStepButton onClick={() => handleNextStep(3)} />
					</>
				</Accordion>
			)}
			<Accordion
				step={2 + showOptions}
				maxStep={3 + showOptions}
				title="CancellationInsuranceLabel"
				disabled={step < 2 + showOptions}
				isOpenInit={step === 2 + showOptions}
				classNameInner="flex w-full flex-col items-start gap-6"
			>
				<>
					<InsuranceCancellationPanel />
					<NextStepButton onClick={() => handleNextStep(3 + showOptions)} />
				</>
			</Accordion>
			<Accordion
				step={3 + showOptions}
				maxStep={3 + showOptions}
				title="FactsLabel"
				disabled={step < 3 + showOptions}
				isOpenInit={step === 3 + showOptions}
				classNameInner="flex w-full flex-col items-start gap-6"
			>
				<>
					<div className="flex w-full flex-col gap-2">
						<Text>{_`FactsInfoLine1`}</Text>
						<Text variant="xsmall">{_`FactsInfoLine2`}</Text>
					</div>
					<ContactInputs />
					<AddressInputs />
					<div className="flex w-full flex-col items-start gap-8">
						<ConsentsInputs />
						<div className="flex flex-col gap-2">
							<ReservationSubmitButton />
							<Text variant="small">{_`ReservationAdditionalComment`}</Text>
						</div>
					</div>
				</>
			</Accordion>
		</>
	)
}

export default ReservationSteps
